import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgGreenTeaGlyphSecondary from './svgs/GreenTeaGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var greenTeaGlyph = (props => useIcon(null, SvgGreenTeaGlyphSecondary, props));

export { greenTeaGlyph as default };
